module.exports = __webpack_public_path__ + "static/project-4a-e69e752e5a7838b0fa6953e9f3d4cf8e.png";